export var CriticalPriorityAgingMapper = function (data) {
    var _a;
    var agingData = [];
    agingData = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.map(function (item) {
        return {
            scheduleDate: item.scheduleDate,
            followupDate: item.followupDtae,
            leadId: item.leadid,
            noOfDays: item.noOfDays,
            priority: item.priority,
            dealerEmpCode: item.dealerEmpCode,
            name: item.name,
        };
    });
    var updatedData = {
        requestId: data.requestid,
        success: data.success,
        message: data.message,
        statuscode: data.statuscode,
        errors: data.errors,
        currentPage: data.currentpage,
        pagesize: data.pagesize,
        totalPages: data.totalpages,
        totalItems: data.totalitems,
        orderby: data.orderby,
        orderByDesc: data.orderbydesc,
        criticalPriorityAgingData: agingData,
    };
    return updatedData;
};
